import { render, staticRenderFns } from "./lang.vue?vue&type=template&id=566ca713"
import script from "./lang.vue?vue&type=script&lang=js"
export * from "./lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports